type ReaderMetrics = {
  captureMode?: 'scan' | 'upload'
  scan?: unknown
  init?: { clientInfo?: { client?: unknown; backend?: unknown }; downloadTime?: number; totalTime?: number }
  cut?: { totalTime?: number }
  read?: { totalTime?: number }
  readBack?: { totalTime?: number }
}

type ReadSide = {
  metrics?: ReaderMetrics
  ocrRows?: unknown[]
  ineType?: { type?: string; conf?: number }
  mrzData?: { isValid?: boolean } | null
}

/** Same shape as alce-id-reader's buildReadSessionSummary, from the front/back results. */
export default function buildSessionSummary(
  front: ReadSide | undefined,
  back: ReadSide | undefined,
  source?: 'web' | 'mobile',
) {
  const metrics: ReaderMetrics = { ...(front?.metrics ?? {}), ...(back?.metrics ?? {}) }
  const clientInfo = metrics.init?.clientInfo
  const ineType = front?.ineType
  return {
    service: 'alce_reader',
    source: source ?? 'web',
    captureMode: metrics.captureMode ?? 'upload',
    scan: metrics.scan,
    clientData: clientInfo?.client,
    backend: clientInfo?.backend,
    elapsed: {
      cutMs: metrics.cut?.totalTime,
      readMs: metrics.read?.totalTime,
      readBackMs: metrics.readBack?.totalTime,
      initDownloadMs: metrics.init?.downloadTime,
      initTotalMs: metrics.init?.totalTime,
    },
    result: {
      frontFields: front?.ocrRows?.length,
      mrzValid: back?.mrzData?.isValid,
      ineType: ineType?.type,
      ineTypeConf: ineType?.conf != null ? Math.round(ineType.conf * 100) / 100 : undefined,
    },
    completedAt: Date.now(),
  }
}
